// extracted by mini-css-extract-plugin
module.exports = {"icon":"Login_icon__2aCpc","buttons":"Login_buttons__zGVm-","button":"Login_button__mFr63","loader":"Login_loader__1M4Ya"};